import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Paper, TableContainer, TableHead, TableRow, TableCell, Table, TableBody, Checkbox, Button } from '@material-ui/core';
import HelpToolTip from '../HelpToolTip';
import ReactLoading from 'react-loading';

const styles = () => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '20px',
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        minWidth: 1000,
    },
    cell: {
        display: 'block',
    },
    wordBreak: {
        width: '100%',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
    },
    lengthTypography: {
        fontSize: '18px',
        marginTop: '10px',
    },
    center: {
        justifyContent: 'center',
        alignItems:'center',
        margin: '50px auto 50px auto',
    }
});

//ヘルプアイコンの文言
const infoText = '同じユーザからのアンケートにチェックを入れた場合は、\n１人としてカウントします。';

function QuestionnaireUserTableHead(props) {
    const { classes, order, orderBy, allUpdateFlg, allUpdate, allData, headCells } = props;

    return (
        <React.Fragment>
            <TableHead className={classes.tableHeadColor}>
                <TableRow>
                    {headCells.map((headCell) => {
                        return (
                            ( (headCell.displayFlg && allData.length !== 0 ) && (
                                <TableCell
                                    key={headCell.id}
                                    align={headCell.numeric ? 'right' : 'left'}
                                    padding={headCell.disablePadding ? 'none' : 'default'}
                                    sortDirection={orderBy === headCell.id ? order : false}
                                >
                                    {headCell.label}
                                    { headCell.id === 'check'  && (
                                        <Checkbox
                                            checked={allUpdateFlg}
                                            onChange={(event) => allUpdate(event)}
                                        />
                                    )}
                                </TableCell>
                            ))
                        );
                    })}
                </TableRow>
            </TableHead>
        </React.Fragment>
    );
}

const QuestionnaireUserTable = (props) => {
    const { classes, datas, allData, setData, allUpdate, setAllUpdate, isLoading, headCells } = props;
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('recordId');
    const [update, setUpdata]= React.useState(false);
    const handleRequestSort = (_event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangeAllUserCheck = (event) => {
        const copyAllData = allData;
        let res;
        if(!allUpdate){
            res = window.confirm('すべて選択しますか？');
        }
        else{
            res = window.confirm('すべての選択を解除しますか？');
        }
        if(res){
            for(let i = 0; i < copyAllData.length; i++ ){
                copyAllData[i].checked = event.target.checked;
            }
            setData(copyAllData);
            setAllUpdate(allUpdate ? false : true);
        }
    };


    const handleChangeUserCheck = (event, userData) => {
        const copyAllData = allData;
        for(let i = 0; i < copyAllData.length; i++ ){
            if(copyAllData[i].recordId === userData.recordId){
                copyAllData[i].checked = event.target.checked;
                break;
            }
        }
        setUpdata(update ? false : true);
        setData(copyAllData);
    };

    //ユーザIDの重複を排除した送信人数の計算
    const dupDataLength = () => {
        const user = [];
        allData.map((d) => {
            if(d.checked){
                const userIndex = user.findIndex((findItem) => {
                    return d.userId === findItem.userId;
                });
                if( userIndex === -1 ) user.push(d);
            }
        });
        return user.length;
    }

    return (
        <React.Fragment>
            { isLoading ? (
                <ReactLoading
                    className={classes.center}
                    type={'spin'}
                    color={'black'}
                    height={'50px'}
                    width={'50px'}
                />
            )
            :
            (
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="draft table">
                            <QuestionnaireUserTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={datas.length}
                                allUpdateFlg={allUpdate}
                                allUpdate={handleChangeAllUserCheck}
                                allData={allData}
                                headCells={headCells}
                            />

                            <TableBody>
                                {datas.map((data, index) => {
                                    const labelId = `deliveryError-data-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            // key={data.recordId}
                                            key={data.recordId}
                                        >
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[0].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[0].textAlign}}
                                            >

                                            <Checkbox
                                                checked={data.checked} onChange={(event) => handleChangeUserCheck(event, data)}
                                            />
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[1].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[1].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.recordId}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[2].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[2].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.creationTime}</p>
                                                </div>
                                            </TableCell>

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[3].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[3].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <p>{data.userId}</p>
                                                </div>
                                            </TableCell>

                                            { headCells[4].displayFlg === true && (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[4].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[4].textAlign}}
                                                >
                                                    <div className={classes.cell}>
                                                        { data.additionalTableData[0] !== undefined && (
                                                            <p>{data.additionalTableData[0].value}</p>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            { headCells[5].displayFlg === true && (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[5].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[5].textAlign}}
                                                >
                                                    <div className={classes.cell}>
                                                        { data.additionalTableData[1] !== undefined && (
                                                            <p>{data.additionalTableData[1].value}</p>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            { headCells[6].displayFlg === true && (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[6].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[6].textAlign}}
                                                >
                                                    <div className={classes.cell}>
                                                        { data.additionalTableData[2] !== undefined && (
                                                            <p>{data.additionalTableData[2].value}</p>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            { headCells[7].displayFlg === true && (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[7].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[7].textAlign}}
                                                >
                                                    <div className={classes.cell}>
                                                        { data.additionalTableData[3] !== undefined && (
                                                            <p>{data.additionalTableData[3].value}</p>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            { headCells[8].displayFlg === true && (
                                                <TableCell
                                                    component="th"
                                                    id={labelId}
                                                    // scope='row'
                                                    padding={headCells[8].disablePadding ? 'none' : 'default'}
                                                    align={'center'}
                                                    style={{minWidth: '100px', textAlign: headCells[8].textAlign}}
                                                >
                                                    <div className={classes.cell}>
                                                        { data.additionalTableData[4] !== undefined && (
                                                            <p>{data.additionalTableData[4].value}</p>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}

                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                // scope='row'
                                                padding={headCells[9].disablePadding ? 'none' : 'default'}
                                                align={'center'}
                                                style={{minWidth: '100px', textAlign: headCells[9].textAlign}}
                                            >
                                                <div className={classes.cell}>
                                                    <Button variant="contained" onClick={() => window.open(data.url, '_blank')}>詳細</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
            { allData.length !== 0 && !isLoading && (
                <Typography className={classes.lengthTypography}>
                    {`送信人数：${dupDataLength()}人`}
                    <HelpToolTip infoText={infoText} />
                </Typography>
            )}
        </React.Fragment>
    );
};

QuestionnaireUserTable.propTypes = {
    classes: PropTypes.object.isRequired,
    datas: PropTypes.array.isRequired,
    allData: PropTypes.array.isRequired,
    setData: PropTypes.func.isRequired,
};

QuestionnaireUserTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    allUpdateFlg: PropTypes.bool.isRequired,
    allUpdate: PropTypes.func.isRequired,
    allData: PropTypes.array.isRequired
};

export default withStyles(styles)(QuestionnaireUserTable);